import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { convertToLocalCurrency } from "../../../utils/currency";
import { getTopAdvertisers } from "../../../redux/slices/dashboardSlice";
const AllAdvertisers = () => {
  const dispatch = useDispatch();
  const { topAdvertisers } = useSelector((state) => state.dashboard);
  useEffect(() => {
    dispatch(getTopAdvertisers());
  }, [dispatch]);
  return (
    <AdvertiserList>
      {topAdvertisers.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          No advertiser available.
        </div>
      ) : (
        topAdvertisers.slice(0, 3).map((advertiser) => (
          <AdvertiserCard>
            <AdvertiserHeader>
              {/* <img src={advertiser.imageUrl} alt={advertiser.name} /> */}
              <h4>
                {advertiser?.firstname} {advertiser?.lastname}
              </h4>
            </AdvertiserHeader>
            <Stats>
              <Stat>
                <Label>Campaigns</Label>
                <Value>{advertiser?.totalcampaigns}</Value>
              </Stat>
              <Stat>
                <Label>Conversions</Label>
                <Value>{advertiser?.totalacquistion}</Value>
              </Stat>
              <Stat>
                <Label>Amount spent</Label>
                <Value>
                  {convertToLocalCurrency(advertiser?.totalamountspent)}
                </Value>
              </Stat>
            </Stats>
          </AdvertiserCard>
        ))
      )}
    </AdvertiserList>
  );
};

export default AllAdvertisers;

const AdvertiserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdvertiserCard = styled.div`
  //display: flex;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;
const AdvertiserHeader = styled.div`
  display: flex;
  gap: 20px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
  h4 {
    margin-top: 15px;
    font-size: 16px;
    text-transform: capitalize;
  }
`;
const Stats = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 12px;
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  text-align: left;
`;

const Label = styled.span`
  font-size: 12px;
  color: #989fad;
`;

const Value = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #48505e;
`;
